import { PipeResult as EnginePipeResult } from "@imi-ernd-be/hyselect-engine";
import { buildSuggestionOutput } from "./buildSuggestion";

export type SuggestionPipe = NonNullable<
  ReturnType<typeof buildSuggestionPipe>
>;

export function buildSuggestionPipe(pipe: EnginePipeResult | null) {
  if (!pipe) return null;
  const result = {
    linearDp: buildSuggestionOutput(pipe.linearDp()),
    size: buildSuggestionOutput(pipe.size()),
    velocity: buildSuggestionOutput(pipe.velocity()),
  };
  return {
    linearDp: isPipeValueEmpty(result.linearDp) ? null : result.linearDp,
    size: isPipeValueEmpty(result.size) ? null : result.size,
    velocity: isPipeValueEmpty(result.velocity) ? null : result.velocity,
  };
}

function isPipeValueEmpty(pipe: { value: number | string }) {
  if (typeof pipe.value === "number") {
    return isNaN(pipe.value) || pipe.value === 0;
  }
  return pipe.value === "0" || pipe.value === "";
}
